angular.module('qkr').controller('FeedbackModalController', ($scope, $uibModalInstance, feedbackService, utils, FormHelper, params, gettextCatalog) => {
	$scope.mssFeedback = {};
	
	// Description, pagName, merchantName
	
	$scope.mssFeedback.description = params[0];
	
	$scope.mssFeedback.merchantName = params[2];
	
	$scope.mssFeedback.pagName = params[1];
	
	$scope.saving = false;
	
	if ($scope.mssFeedback.description) {
		$scope.showSaveBtn = false;
		$scope.mssFeedback.description = params[0];
	} else {
		$scope.showSaveBtn = true;
	}
	
    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };
    
    $scope.saveFeedback = function() {
    	$scope.saving = true;
    	if (!$scope.validateForm()) {
    		return;
    	}
    	
    	const request = angular.copy($scope.mssFeedback);	
    		
    	feedbackService.saveFeedback(request)
    	  	.then((promise) => {
    	  			$uibModalInstance.close(promise);
                },
                (promise) => {
                	new FormHelper($scope).handleResponse(promise);
                });
    };
 
    $scope.validateForm = function() {
    	$scope.errors = {};
    	let valid = true;
    	
    	if (utils.hasNoValue($scope.mssFeedback.description)) {
             $scope.errors.description = gettextCatalog.getString('Please enter a description');
             valid = false;
        }
    	
    	return valid;
    };
});



// WEBPACK FOOTER //
// ./src/controllers/modal/feedback.modal.controller.js